import { render, staticRenderFns } from "./donut.vue?vue&type=template&id=fbd4b390&"
import script from "./donut.vue?vue&type=script&lang=js&"
export * from "./donut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports